// extracted by mini-css-extract-plugin
export default {"wrapper":"_d683cb3","headerWrapper":"_cbbb60c","img":"_6717ae23","imgWrapper":"_b6762a10","browseMoreWrapper":"_3535d218","overlayWrapper":"_574115e9","overlay":"_923c175a"};